import React, { createContext, useEffect, useState } from "react";
import bsTranslations from "../assets/translations/bs.json";
import srTranslations from "../assets/translations/sr.json";
import enTranslations from "../assets/translations/en.json";

export const SUPPORTED_LANGUAGES = ["bs", "sr", "en"];
export const DEFAULT_LANGUAGE = "bs";

const TRANSLATIONS = {
    bs: bsTranslations,
    sr: srTranslations,
    en: enTranslations,
};

export const LanguageContext = createContext({
    language: DEFAULT_LANGUAGE,
    translations: TRANSLATIONS[DEFAULT_LANGUAGE],
    switchLanguage: () => {},
    setLanguage: () => {},
});

export const LanguageProvider = ({ children }) => {
    const [language, setLanguageState] = useState(() => {
        const stored = localStorage.getItem("language");
        return SUPPORTED_LANGUAGES.includes(stored) ? stored : DEFAULT_LANGUAGE;
    });

    useEffect(() => {
        localStorage.setItem("language", language);
        document.documentElement.lang = language;
    }, [language]);

    const setLanguage = (lang) => {
        if (SUPPORTED_LANGUAGES.includes(lang)) {
            setLanguageState(lang);
        }
    };

    const switchLanguage = () => {
        const idx = SUPPORTED_LANGUAGES.indexOf(language);
        const next = SUPPORTED_LANGUAGES[(idx + 1) % SUPPORTED_LANGUAGES.length];
        setLanguageState(next);
    };

    const translations = TRANSLATIONS[language] || TRANSLATIONS[DEFAULT_LANGUAGE];

    return (
        <LanguageContext.Provider value={{ language, translations, switchLanguage, setLanguage }}>
            {children}
        </LanguageContext.Provider>
    );
};